<!--
    课程商品-统计列表-授权账号数详情
    作用：展示授权账号详情
    组件：el-dialog、el-table
-->
<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="handleClose"
    :title="curRow.auth_status == 1?'授权账号数详情':'取消账号数详情'"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-table
      v-loading="isLoading"
      ref="multipleTable"
      :data="tableData"
      row-key="search_staff_mobile"
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column
        v-for="(item,index) in tableHead"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        :formatter="item.formatter"
      />
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  name: 'UsersInfoDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    curRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableHead: [{
        prop: 'to_users_name',
        label: '用户名称',
      }, {
        prop: 'to_users_phone',
        label: '用户手机号',
      },
      {
        label: '授权状态',
        formatter: (row) => {
          const type = {
            1: '已授权',
            2: '取消授权',
          };
          return type[row.auth_status];
        },
      }],
      isLoading: false,
      selList: [],
      tableData: [],
      submitLoading: false,
    };
  },
  mounted() {
    const newArr = [];
    this.curRow.users.forEach((item) => {
      // if (item.auth_status === this.curRow.auth_status) {
      //   newArr.push(item);
      // }
      newArr.push(item);
    });
    this.tableData = newArr;
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.btns{
  text-align: right;
  padding-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/CourseGoods/AuthorityStatistics/usersInfoDialog.vue